export default __webpack_public_path__ + "static/media/pot4-big.bcf5c21b.jpg";